import { useState, useEffect } from 'react';

/**
 * Hook para calcular o tamanho responsivo da roda baseado na largura da tela
 */
export const useWheelSize = () => {
  const [wheelSize, setWheelSize] = useState(400);

  useEffect(() => {
    const updateWheelSize = () => {
      const width = window.innerWidth;
      if (width < 640) { // mobile
        setWheelSize(Math.min(width - 40, 350));
      } else if (width < 768) { // tablet
        setWheelSize(400);
      } else { // desktop
        setWheelSize(434);
      }
    };

    updateWheelSize();
    window.addEventListener('resize', updateWheelSize);
    return () => window.removeEventListener('resize', updateWheelSize);
  }, []);

  return wheelSize;
};
